import clsx from 'clsx';
import { Box, Select } from '@bigcommerce/big-design';

export function FilterSelect(props) {
	return (
		<Box
			marginTop="small"
			className={clsx('selectBox', props.wrapperClass)}
		>
			<Select
				marginTop="large"
				label={props.placeholder}
				placeholder={props.placeholder}
				{...props}
			/>
		</Box>
	);
}
